import {GetCharacterItemStore} from '@/graphql/queries/CharacterItemStore.graphql'
import {GetStoryItemList} from '@/graphql/queries/StoryItem.graphql'

export default {
  apollo    : {
    storyItems  : {
      query : GetStoryItemList,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },
    
    characterItemStoreList : {
      query : GetCharacterItemStore,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },
  
  methods   : {
    couldUseStoryItemValidation(storyItemSlug){
      // まず、対象となるアイテムのモデルを探します。
      const storyItem = this.lookUpStoryItemFromList(storyItemSlug);

      if(storyItem === null){
        this.runFlashMessageEmtpyRequireItem({
          messageTemplate : 'アイテムを確認することができませんでした。'
        });

        return false;
      }

      // アイテム自体があるので、キャラクターがアイテムを持っているか確認します。
      const targetItemStore = this.lookUpStoryItemStoreFromCharacterStoreList(
        storyItemSlug,
        this.characterItemStoreList
      );
      
      if( (targetItemStore === null) || (targetItemStore.quantity === 0) ){
        this.runFlashMessageEmtpyRequireItem({
          itemName  : storyItem.name
        });

        return false;
      }

      return targetItemStore;
    },

    displayUseStoryItemConfirmModal(parameters){
      let itemRequireAmount = null;

      const modalParameters = {
        templateName        : parameters.templateName,
        itemName            : parameters.characterItemStore.item.name,
        itemImageSlug       : parameters.characterItemStore.item.slug,

        quantity            : 0,
        total               : 0,
        remain              : 0,

        disableSubmitButton : false,
        lineMessage         : null
      };

      if(typeof parameters.itemRequireAmount !== 'undefined'){
        itemRequireAmount = parameters.itemRequireAmount;
      }

      // 必要なアイテム数がnullでない場合はアイテムが足りているか確認します。
      if(itemRequireAmount !== null){
        // アイテムを使用した際の残数等を取得します。
        const itemStoreAmount = this.getItemStoreAmount(parameters.characterItemStore, itemRequireAmount);

        modalParameters.quantity  = itemStoreAmount.quantity;
        modalParameters.total     = itemStoreAmount.total;
        modalParameters.remain    = itemStoreAmount.remain;
        
        if( itemStoreAmount.couldUse === false ){
          modalParameters.disableSubmitButton = true;
          modalParameters.lineMessage         = 'アイテムが不足しています。';
        }
      }

      this.$store.dispatch({
        type                    : 'itemUseModal/updateOpenModal',

        value                   : true,

        templateName            : modalParameters.templateName,

        meta                    : {
          itemName      : modalParameters.itemName,
          itemImageSlug : modalParameters.itemImageSlug,
          quantity      : modalParameters.quantity,
          total         : modalParameters.total,
          remain        : modalParameters.remain,
        },

        handleSubmitFunction    : () => {
          if(typeof parameters.handleSubmitFunction === 'function'){
            parameters.handleSubmitFunction();
          }
        },

        handleCancelFunction    : () => {
          if(typeof parameters.handleCancelFunction === 'function'){
            parameters.handleCancelFunction();
          }
        },

        isDisabledSubmimtbutton : modalParameters.disableSubmitButton,
        lineMessage             : modalParameters.lineMessage
      });
    },

    runFlashMessageEmtpyRequireItem(parameters){
      if(typeof parameters.messageTemplate === 'undefined'){
        parameters.messageTemplate = '&nbsp;[[itemName]]が不足しています。';
      }

      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : this.textReplacer(parameters.messageTemplate, parameters),
        status      : 'error',
        hasControl  : true,
        autoClose   : 8000
      }, {root:true});
    },

    lookUpStoryItemFromList(storyItemSlug){
      for(let i = 0; i < this.storyItems.length; i++){
        if( this.storyItems[i].slug === storyItemSlug ){
          return this.storyItems[i];
        }
      }

      return null;
    },

    lookUpStoryItemStoreFromCharacterStoreList(storyItemSlug, characterStoryItemList){
      let targetStoryItemStore = null;
      
      for(let characterStoryItemStore of characterStoryItemList){
        if(characterStoryItemStore.item.slug === storyItemSlug){
          targetStoryItemStore = characterStoryItemStore;
        }
      }

      return targetStoryItemStore;
    }
  }
}